import { Body, Divider, Footnote, HStack, Icon, Space, Subhead, VStack } from "@themeable/react";
import { Cell } from "@themeable/react-components";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const TopicJumper = ({ blocks }) => {

  const navigate = useNavigate()

  const handleScrollToAnchor = (id) => {
    navigate(`#${id}`)
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const id = hash.substring(1); // Remove the '#' character
      handleScrollToAnchor(id);
    }
  }, [blocks, location]);

  return (
    <VStack align='top'>
      {blocks.map((block, index) => (
        <>
          {(() => {
            switch (block.type) {
              case 'heading_1': return (
                <>
                  {block.heading_1.rich_text[0].plain_text.includes('##') ? (
                    <>
                      <Divider nested />
                      <Cell
                        onClick={() =>
                          handleScrollToAnchor(
                            block
                              .heading_1
                              .rich_text[0]
                              .plain_text
                              .substring(4)
                              .toLowerCase()
                              .trim()
                              .replace(/\s+/g, '-')
                              .replace(/[^a-z0-9-]/g, '')
                          )
                        }
                      >
                        <HStack align='middle center'>
                          <Icon
                            name={block.heading_1.rich_text[0].plain_text.substring(2, 4).trim()}
                            color='accent'
                          />
                          <Space.Content />
                          <Subhead weight='bold'>{block.heading_1.rich_text[0].plain_text.substring(3)}</Subhead>
                        </HStack>
                      </Cell>
                    </>
                  ) : (
                    <>
                      <Divider nested />
                      <Cell
                        onClick={() =>
                          handleScrollToAnchor(
                            block
                              .heading_1
                              .rich_text[0]
                              .plain_text
                              .toLowerCase()
                              .trim()
                              .replace(/\s+/g, '-')
                              .replace(/[^a-z0-9-]/g, '')
                          )
                        }
                      >
                        <Subhead weight='bold'>{block.heading_1.rich_text[0].plain_text}</Subhead>
                      </Cell>
                    </>
                  )}
                </>
              )
                break;
              case 'heading_2': return (
                <>
                  {block.heading_2.rich_text[0].plain_text.includes('##') ? (
                    <Cell
                      onClick={() =>
                        handleScrollToAnchor(
                          block
                            .heading_2
                            .rich_text[0]
                            .plain_text
                            .substring(4)
                            .toLowerCase()
                            .trim()
                            .replace(/\s+/g, '-')
                            .replace(/[^a-z0-9-]/g, '')
                        )}
                    >
                      <HStack align="top" group>
                        <Icon
                          name={block.heading_2.rich_text[0].plain_text.substring(2, 4).trim()}
                          color='accent'
                        />
                        <Space.Content />
                        <Footnote>{block.heading_2.rich_text[0].plain_text.substring(3)}</Footnote>
                      </HStack>
                    </Cell>
                  ) : (
                    <Cell
                      onClick={() =>
                        handleScrollToAnchor(
                          block
                            .heading_2
                            .rich_text[0]
                            .plain_text
                            .toLowerCase()
                            .trim()
                            .replace(/\s+/g, '-')
                            .replace(/[^a-z0-9-]/g, '')
                        )}
                    >
                      <HStack>
                        <Space.Content />
                        <Space.Content />
                        <Footnote>{block.heading_2.rich_text[0].plain_text}</Footnote>
                      </HStack>
                    </Cell>
                  )}
                </>
              )
                break;
              default: return ''
                break;
            }
          })()}
        </>
      ))}

    </VStack>
  )
}
